<app-carrier-form
  [defaultValues]="editableCarrier"
  [carrierType]="editableCarrierType"
  [carrierFields]="editableCarrierFields"
  [pending]="pending$ | async"
  [formLoaded]="formFieldsLoaded"
  [errorMessage]="errorMessage$ | async"
  (submitForm)="onSubmitForm($event)"
  [submitButtonName]="submitButton"
  [timeZone]="ianaTimeZone"
  [operationMode]="'edit'"
  [isOnTrialPlan]="isOnTrialPlan">
</app-carrier-form>
